import React, { useState, useEffect } from "react"

import { Button, Card, CardContent, Grid } from "@mui/material"
import { TCInput } from "components/TopCourtComponents/Input/TopCourtInput"
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel"

import { getSportCourtTypes } from "services/placeServices"

import { getCourtTypes } from "services/placeServices"
import { courtTypeOption } from "constant/constant"

import Select from "react-select";
import { IconTrash, IconArrowBackUp } from "@tabler/icons"
import { validation } from "helper/Form"

const form = {
    name: "",
    sportCourtTypeSelected: ""
}

function CourtListComponent({
    data,
    index,
    saveCourt,
    formId,
    deleteCourt,
    merchantId
}) {
    const [sportCourtTypeOptions, setSportCourtTypeOptions] = useState([])
    const [joi, setJOI] = useState({
        ...form
    })

    const loadSportCourtTypeOptions = async () => {
        let { data, error } = await getSportCourtTypes({ isActive: true, merchantId, placeId: formId })
        if (error) { console.log(error) }
        if (data) {
            let sportCourtType = []
            for (let i = 0; i < data.length; i++) {
                sportCourtType.push({
                    label: data[i].sportTypeId?.name + ' ' + data[i].courtTypeId?.name,
                    value: data[i]._id
                })
            }
            setSportCourtTypeOptions(sportCourtType)
        }
    }

    const [courtType, setCourtType] = useState(courtTypeOption)

    // const loadCourtType = async () => {
    //     let { data, error } = await getCourtTypes({ isActive: true })
    //     if (error) { console.log(error) }
    //     if (data) {
    //         let courtType = []
    //         for (let i = 0; i < data.length; i ++) {
    //             courtType.push({
    //                 label: data[i].name,
    //                 value: data[i].courtType
    //             })
    //         }
    //         setCourtType(courtType)
    //     }
    // }

    const [courtForm, setCourtForm] = useState({
        name: "",
        price: 0,
        ...data,
        type: data.courtType ? getOptionObject({ value: data.courtType, options: courtType }) : "",
        isCourtDeleted: false
    })

    const onChangeForm = (e) => {
        setCourtForm(prev => ({
            ...prev,
            ...e
        }))
    }

    // useEffect(() => {
    //     loadCourtType()
    // }, [])

    useEffect(() => {
        setCourtForm(prev => ({
            ...prev,
            type: data.courtType ? getOptionObject({ value: data.courtType, options: courtType }) : "",
        }));
    }, [courtType]);

    useEffect(() => {
        loadSportCourtTypeOptions()
    }, [])

    useEffect(() => {
        setCourtForm(prev => ({
            ...prev,
            sportCourtTypeSelected: data.sportCourtTypeId ? getOptionObject({ value: data.sportCourtTypeId, options: sportCourtTypeOptions }) : "",
        }));
    }, [sportCourtTypeOptions]);

    useEffect(() => {
        if (courtForm.isCourtDeleted) {
            setJOI(prev => ({
                ...form
            }))
        } else {
            setJOI(prev => ({
                name: !validation.isNotEmpty(courtForm.name) ? '*required' : "",
                sportCourtTypeSelected: !validation.isNotEmpty(courtForm.sportCourtTypeSelected) ? '*required' : ''
            }))
        }
        saveCourt(courtForm, index)
    }, [courtForm])

    const updateCourt = async () => {
        let courtList = courtForm.isCourtDeleted
        if (courtList) {
            courtList = false
        } else {
            courtList = true
        }
        setCourtForm(prev => ({
            ...prev,
            isCourtDeleted: courtList
        }))
    }

    return (
        <Card sx={{
            mt: 1,
            boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;"
        }}>
            <div style={{ padding: 10 }}>
                <div style={{
                    width: '100%',
                    textAlign: 'right',
                }}>
                    {
                        (courtForm.isCourtDeleted) ?
                            <IconArrowBackUp style={{
                                cursor: 'pointer',
                                color: '#4caf50'
                            }} onClick={() => {
                                updateCourt()
                            }} />
                            :
                            <IconTrash style={{
                                cursor: 'pointer',
                                color: 'red'
                            }} onClick={() => {
                                if (formId) {
                                    updateCourt()
                                    setJOI(prev => ({
                                        ...form
                                    }))
                                } else {
                                    deleteCourt(data._id)
                                }
                            }} />
                    }
                </div>
                <Grid container xs={12} style={{
                    opacity: (courtForm.isCourtDeleted) ? 0.5 : 1,
                    transition: "all 0.3s ease-in-out"
                }}>
                    <Grid xs={6} sx={{ p: 1 }}>
                        <TCLabel showAlert={joi.name}>Court Name</TCLabel>
                        <TCInput value={data.name} onChange={(e) => {
                            if (e.currentTarget.value.length > 51) return
                            onChangeForm({ name: e.currentTarget.value })
                        }} placeHolder="Input court name" disabled={courtForm.isCourtDeleted} inputProps={{ maxLength: 50 }}></TCInput>
                    </Grid>
                    <Grid xs={6} sx={{ p: 1 }}>
                        <TCLabel showAlert={joi.sportCourtTypeSelected}>Sport Court Type</TCLabel>
                        <Select value={courtForm.sportCourtTypeSelected}
                            isDisabled={courtForm.isCourtDeleted}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            onChange={(e) => {
                                onChangeForm({
                                    sportCourtTypeSelected: e,
                                    sportCourtTypeId: e.value
                                })
                            }} options={sportCourtTypeOptions} />
                    </Grid>
                </Grid>
                {/* <TCLabel>{currencyFormat(data.price)}</TCLabel> */}
            </div>
        </Card>
    )
}

function getOptionObject({
    value, options
}) {
    let selectedValue = null
    for (let i = 0; i < options.length; i++) {
        if (options[i].value === value) {
            selectedValue = options[i]
        }
    }
    return selectedValue
}

export default CourtListComponent